import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTranslation } from 'react-i18next';
import { premiumButtonSx } from 'common/theme/button/premiumButtonSx';

/**
 * Modal de confirmación GENÉRICO (no destructivo) monocromo OTRIX. A diferencia de
 * ConfirmDeleteModal (rojo), este usa el CTA premium para acciones como "Solicitar ejercicio".
 * El usuario puede confirmar o retractarse (seguir editando / cancelar).
 */
function ConfirmActionModal({
  open,
  title,
  message,
  confirmLabel = null,
  cancelLabel = null,
  loading = false,
  onConfirm,
  onClose
}) {
  const { t } = useTranslation(['labels', 'buttons']);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, backgroundColor: 'surface.content', backgroundImage: 'none', border: '1px solid', borderColor: 'hairline.main' } }}
    >
      <DialogTitle sx={{ textAlign: 'center', pt: 4, pb: 1 }}>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
          <HelpOutlineIcon sx={{ color: 'gold.main', fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.primary' }}>{title}</Typography>
        </Stack>
        <IconButton onClick={onClose} size="small" sx={{ position: 'absolute', right: 8, top: 8, color: 'text.secondary', '&:hover': { color: 'text.primary', backgroundColor: 'rgba(255,255,255,0.08)' } }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: 4, py: 2 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
        <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
          <Button onClick={onClose} fullWidth variant="outlined" color="inherit" sx={{ py: 1.2, borderRadius: 2, color: 'text.primary', borderColor: 'hairline.strong', fontWeight: 700, textTransform: 'none' }}>
            {cancelLabel || t('cancel', { ns: 'buttons', defaultValue: 'Cancelar' })}
          </Button>
          <Button onClick={onConfirm} fullWidth disabled={loading} sx={{ ...premiumButtonSx, py: 1.2, fontSize: '0.95rem' }}>
            {confirmLabel || t('confirm', { ns: 'buttons', defaultValue: 'Confirmar' })}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}

ConfirmActionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  loading: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ConfirmActionModal;
